import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';
import MIcon from '../../../common/m-icon/MIcon';

function SocialMedia() {
    const { t } = useTranslation();
    return (
      <div className='desktop:w-1/2 text-footer-text text-sm flex flex-col mb-4 order-3 desktop:order-4 mx-2'>
          <p className='font-bold mb-2'>{t('general.footer.socialMedia')}</p>

          <div className='flex flex-row'>
              <a
                className='social-media-btn'
                href='https://www.facebook.com/profile.php?id=61566195591538'
                target='_blank'
                rel='noreferrer'
              >
                  <MIcon
                    type={'facebook'}
                    className={'text-white cursor-pointer'}
                  />
              </a>

              <a
                className='social-media-btn'
                href='https://www.instagram.com/oqulyqtar_kz?igsh=Y2hwdmF5MTE5eWVk'
                target='_blank'
                rel='noreferrer'
              >
                  <MIcon
                    type={'instagram'}
                    className={'text-white cursor-pointer'}
                  />
              </a>

              <a
                className='social-media-btn flex items-center'
                href='https://youtube.com/@oqulyqtar?si=m799mYnBx6nmiebH'
                target='_blank'
                rel='noreferrer'
              >
                  <MIcon
                    type={'youtube'}
                    className={'text-white cursor-pointer'}
                  />
              </a>
              <a
                className='social-media-btn'
                href='https://www.tiktok.com/@oqulyqtar.kz?_t=ZM-8ti498RZLO9&_r=1'
                target='_blank'
                rel='noreferrer'
              >
                  <MIcon
                    type={'tiktok'}
                    className={'text-white cursor-pointer'}
                  />
              </a>
          </div>
      </div>
    );
}

export default memo(SocialMedia);
